import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WholesalerPharmacySelectorComponent } from './wholesaler-pharmacy-selector.component';
import { WholesalerPharmacyService } from '../services';
import { map, Observable } from 'rxjs';
import { CustomB2BUnit, USER_TYPE } from 'src/app/shared/model';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { OLD_QUOTE_CODE, UserUtils } from 'src/app/shared';
import { SharedService } from 'src/app/shared/services/shared.service';

@Component({
  selector: 'app-wholesaler-pharmacy',
  templateUrl: './wholesaler-pharmacy.component.html',
  styleUrls: ['./wholesaler-pharmacy.component.scss'],
})
export class WholesalerPharmacyComponent {
  constructor(
    protected modalService: NgbModal,
    protected wholesalerPharmacyService: WholesalerPharmacyService,
    protected user: UserAccountFacade,
    protected sharedService: SharedService
  ) {
    this.editable =
      this.editable && !this.sharedService.getSessionStorage(OLD_QUOTE_CODE);
  }

  @Input() editable = true;

  userType$ = this.user
    .get()
    .pipe(
      map((user) =>
        UserUtils.isPharmacyUser(user) ? USER_TYPE.PHARMACY : USER_TYPE.NBP
      )
    );
  USER_TYPE = USER_TYPE;

  selected$: Observable<CustomB2BUnit> =
    this.wholesalerPharmacyService.getDefaultWholesalerPharmacy();

  openPopup() {
    this.modalService.open(WholesalerPharmacySelectorComponent);
  }
}
